import { CorePressable } from '@/components/Theme/Core/CorePressable';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const Pressable = withStyles(CorePressable, {noSwitch: true});